export const formatRange = (start, end, lang) => {
  const locale = lang === 'it' ? 'it-IT' : 'en-GB';
  const s = new Date(start);
  const e = new Date(end);
  const month = (d) => d.toLocaleDateString(locale, { month: 'short' }).replace('.', '');
  if (s.getMonth() === e.getMonth()) return `${s.getDate()}–${e.getDate()} ${month(s)}`;
  return `${s.getDate()} ${month(s)} – ${e.getDate()} ${month(e)}`;
};

const icsDate = (iso, addDays = 0) => {
  const d = new Date(iso);
  d.setDate(d.getDate() + addDays);
  return d.toISOString().slice(0, 10).replace(/-/g, '');
};

const escape = (v) => String(v).replace(/\\/g, '\\\\').replace(/;/g, '\\;').replace(/,/g, '\\,').replace(/\n/g, '\\n');

const eventBlock = (e) => [
  'BEGIN:VEVENT',
  `UID:gb-${e.startDate}-${e.id}@giacomobassi`,
  `DTSTAMP:${new Date().toISOString().replace(/[-:]/g, '').split('.')[0]}Z`,
  `DTSTART;VALUE=DATE:${icsDate(e.startDate)}`,
  `DTEND;VALUE=DATE:${icsDate(e.endDate, 1)}`,
  `SUMMARY:${escape(`${e.name} - Giacomo Bassi`)}`,
  `LOCATION:${escape(e.location)}`,
  `DESCRIPTION:${escape(`${e.type} · Giacomo Bassi show jumping · giacomobassi`)}`,
  'END:VEVENT'
].join('\r\n');

export const buildIcs = (list) => [
  'BEGIN:VCALENDAR',
  'VERSION:2.0',
  'PRODID:-//Giacomo Bassi//Show Calendar//IT',
  'CALSCALE:GREGORIAN',
  'METHOD:PUBLISH',
  'X-WR-CALNAME:Giacomo Bassi - Calendario Gare',
  ...list.map(eventBlock),
  'END:VCALENDAR'
].join('\r\n');

export const downloadIcs = (list, filename) => {
  const blob = new Blob([buildIcs(list)], { type: 'text/calendar;charset=utf-8' });
  const url = URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = filename;
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
  setTimeout(() => URL.revokeObjectURL(url), 1000);
};
